import { useMutation } from '@tanstack/react-query';
import { RQAPICall, RQAPICallWithData } from 'store/APIClient';

export function useAddInscriptionProjectMutation() {
    return useMutation({
        mutationFn: ({
            data: body,
        }: {
            data: { inscriptionId: string; projectId: number };
        }) =>
            RQAPICallWithData<{ projectId: number }>({
                endpoint: 'inscriptions_projects',
                body,
                method: 'POST',
            }),
    });
}

export function useDeleteInscriptionProjectMutation() {
    return useMutation({
        mutationFn: ({
            projectId,
            inscriptionId,
        }: {
            projectId: number;
            inscriptionId: string;
        }) =>
            RQAPICall({
                endpoint: `inscriptions_projects?project_id=${projectId}&inscription_id=${inscriptionId}`,
                method: 'DELETE',
            }),
    });
}
